exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-item[data-v-2269eb32]{display:inline-block;margin-right:10px}.list-enter-active[data-v-2269eb32],.list-leave-active[data-v-2269eb32]{transition:all 1s}.list-enter[data-v-2269eb32],.list-leave-to[data-v-2269eb32]{opacity:0;transform:translateY(-30px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2269eb32","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/core/components/mdNotifications/index.vue
// module id = Eds2
// module chunks = 12